export const canEditCaption = (state: string): boolean => ['planned', 'captioning', 'ready', 'failed'].includes(state);
export function captionMutationMessage(result: {changed:boolean;captionQueued?:boolean;disabledReason?:string|null}, action: string): string {
  if (!result.changed) return `${action}: no change.`;
  if (result.captionQueued) return `${action} saved. Caption generation queued.`;
  if (result.disabledReason) return `${action} saved. Generation is waiting (${result.disabledReason.replaceAll('_', ' ')}).`;
  return `${action} saved.`;
}
